var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-warp"},[_c('img',{attrs:{"src":"/static/images/frame/no_auth.svg","alt":"暂无权限","srcset":""},on:{"click":_vm.goLogin}})])}
var staticRenderFns = []

export { render, staticRenderFns }